import { PropsWithChildren } from 'react';

export default function SectionContainer({
  containerId,
  children,
}: { containerId: string } & PropsWithChildren) {
  return (
    <div
      id={containerId}
      className='linkable-container w-full flex flex-col gap-4 px-10'
    >
      {children}
    </div>
  );
}
